<svg width="0" height="0" style="position: absolute" aria-hidden="true">
  <filter id="iconSharpen" x="-20%" y="-20%" width="140%" height="140%">
    <feConvolveMatrix order="3" kernelMatrix="0 -1 0  -1 5 -1  0 -1 0" preserveAlpha="true" />
  </filter>
</svg>

<section class="apps-showcase">
  <div class="apps-wrapper">
    <div class="apps-panel" id="core-modules">
      <div class="section-header">
        <h2>Everything you need, <span class="accent">built in</span></h2>
        <p>Powerful apps to manage your business</p>
      </div>

      <div class="apps-content">
      <div class="apps-group">
        <h3>Core Modules</h3>

        <div class="module-grid">
          <div
            class="module-card"
            *ngFor="let module of visibleCoreModules; trackBy: trackByTile"
            [routerLink]="module.route ?? null"
            [class.tile-link]="module.route"
          >
            <div class="module-icon-box">
              <img [src]="module.image" [alt]="module.name" class="module-icon icon-sharpen" />
            </div>
            <p class="module-title">{{ module.name }}</p>
            <p class="module-desc">{{ module.description }}</p>
            <span class="module-status">Active</span>
          </div>
        </div>

        <button class="expand-button" type="button" (click)="toggleModules()">
          {{ expandedModules ? 'Collapse modules' : 'View all modules' }}
          <svg
            class="arrow"
            [class.rotated]="expandedModules"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <line x1="4" y1="12" x2="19" y2="12"></line>
            <polyline points="13 6 19 12 13 18"></polyline>
          </svg>
        </button>
      </div>

      <div class="apps-group" id="applications">
        <h3>Applications</h3>

        <div class="module-grid">
          <div
            class="module-card"
            *ngFor="let app of visibleApplications; trackBy: trackByTile"
            [routerLink]="app.route ?? null"
            [class.tile-link]="app.route"
          >
            <div class="module-icon-box">
              <img [src]="app.image" [alt]="app.name" class="module-icon" />
            </div>
            <p class="module-title">{{ app.name }}</p>
            <p class="module-desc">{{ app.description }}</p>
            <span class="module-status">Active</span>
          </div>
        </div>

        <button class="expand-button" type="button" (click)="toggleProducts()">
          {{ expandedProducts ? 'Collapse products' : 'View all products' }}
          <svg
            class="arrow"
            [class.rotated]="expandedProducts"
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <line x1="4" y1="12" x2="19" y2="12"></line>
            <polyline points="13 6 19 12 13 18"></polyline>
          </svg>
        </button>
      </div>
      </div><!-- /.apps-content -->
    </div>
  </div>
</section>
